import { AnalyticsBrowser } from '@segment/analytics-next';

import { addErrorInDatadogRum } from '../utilities';

const analytics = AnalyticsBrowser.load({
  writeKey: process.env.GATSBY_SEGMENT_WEB_APP_WRITE_KEY as string,
});

interface SegmentUserAttributes {
  current_subscription_auto_renewal?: boolean;
  email?: string;
}

// eslint-disable-next-line import/prefer-default-export
export const updateUserAttributes = async (userId: string, traits: SegmentUserAttributes) => {
  try {
    await analytics.identify(userId, { ...traits });
  } catch (error) {
    addErrorInDatadogRum(error);
  }
};
